import { ICommonAppState } from "..";

export const currenciesSelector = (state: ICommonAppState) => state.currencies;
